import api from "@/lib/axios";

export const foundationMembersService = {
  getApplications: async (params = {}) => {
    try {
      const response = await api.get("/foundation-members/applications", {
        params,
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch foundation member applications";
      throw new Error(message);
    }
  },
};
